export const SMTs = [
  {
    "Code":"ART ARM",
    "Description":"Arm, nonspecific, artificial"
  },
  {
    "Code":"ART BRSTS",
    "Description":"Breast implant, left and right"
  },
  {
    "Code":"ART ELBOW",
    "Description":"Artificial elbow joint"
  },
  {
    "Code":"ART HIP",
    "Description":"Artificial hip joint"
  },
  {
    "Code":"ART KNEE",
    "Description":"Artificial knee joint"
  },
  {
    "Code":"ART L ARM",
    "Description":"Arm, left, artificial"
  },
  {
    "Code":"ART LARYNX",
    "Description":"Artificial larynx"
  },
  {
    "Code":"ART L BRST",
    "Description":"Breast implant, left"
  },
  {
    "Code":"ART L EAR",
    "Description":"Ear, left, artificial"
  },
  {
    "Code":"ART L EYE",
    "Description":"Eye, left, artificial"
  },
  {
    "Code":"ART L FT",
    "Description":"Foot, left, artificial"
  },
  {
    "Code":"ART L HND",
    "Description":"Hand, left, artificial"
  },
  {
    "Code":"ART L LEG",
    "Description":"Leg, left, artificial"
  },
  {
    "Code":"ART R ARM",
    "Description":"Arm, right, artificial"
  },
  {
    "Code":"ART R BRST",
    "Description":"Breast implant, right"
  },
  {
    "Code":"ART R EAR",
    "Description":"Ear, right, artificial"
  },
  {
    "Code":"ART R EYE",
    "Description":"Eye, right, artificial"
  },
  {
    "Code":"ART R FT",
    "Description":"Foot, right, artificial"
  },
  {
    "Code":"ART R HND",
    "Description":"Hand, right, artificial"
  },
  {
    "Code":"ART R LEG",
    "Description":"Leg, right, artificial"
  },
  {
    "Code":"ART SHLD",
    "Description":"Artificial shoulder joint"
  },
  {
    "Code":"BALD",
    "Description":"Bald balding"
  },
  {
    "Code":"BLIND",
    "Description":"Blind, both eyes"
  },
  {
    "Code":"BLND EYE",
    "Description":"Blind, one eye, nonspecific"
  },
  {
    "Code":"BLND L EYE",
    "Description":"Blind, left eye"
  },
  {
    "Code":"BLND R EYE",
    "Description":"Blind, right eye"
  },
  {
    "Code":"BRAC ARM",
    "Description":"Brace, one arm, nonspecific"
  },
  {
    "Code":"BRACE BACK",
    "Description":"Brace, back"
  },
  {
    "Code":"BRACE NECK",
    "Description":"Brace, neck"
  },
  {
    "Code":"BRAC L ARM",
    "Description":"Brace, left arm"
  },
  {
    "Code":"BRAC LEG",
    "Description":"Brace, one leg, nonspecific"
  },
  {
    "Code":"BRAC L LEG",
    "Description":"Brace, left leg"
  },
  {
    "Code":"BRAC R ARM",
    "Description":"Brace, right arm"
  },
  {
    "Code":"BRAC R LEG",
    "Description":"Brace, right leg"
  },
  {
    "Code":"BRAC TEETH",
    "Description":"Braces, teeth"
  },
  {
    "Code":"BRA LR ARM",
    "Description":"Brace, left and right arms"
  },
  {
    "Code":"BRA LR LEG",
    "Description":"Brace, left and right legs"
  },
  {
    "Code":"CANE",
    "Description":"Cane"
  },
  {
    "Code":"CARD PACEM",
    "Description":"Cardiac pacemaker"
  },
  {
    "Code":"CATA L EYE",
    "Description":"Cataract, left eye"
  },
  {
    "Code":"CATARACT",
    "Description":"Cataract, (nonspecific)"
  },
  {
    "Code":"CATA R EYE",
    "Description":"Cataract, right eye"
  },
  {
    "Code":"CAUL L EAR",
    "Description":"Cauliflower ear, left"
  },
  {
    "Code":"CAUL R EAR",
    "Description":"Cauliflower ear, right"
  },
  {
    "Code":"CLEFT CHIN",
    "Description":"Cleft chin"
  },
  {
    "Code":"CLEFT PAL",
    "Description":"Cleft palate"
  },
  {
    "Code":"CL LIP",
    "Description":"Cleft lip"
  },
  {
    "Code":"COLOST APP",
    "Description":"Colostomy appliances"
  },
  {
    "Code":"CON LENSES",
    "Description":"Contact lenses"
  },
  {
    "Code":"CRIP L ARM",
    "Description":"Crippled arm, left"
  },
  {
    "Code":"CRIP L FGR",
    "Description":"Crippled finger(s), left hand (2)"
  },
  {
    "Code":"CRIP L FT",
    "Description":"Crippled foot, left (3)"
  },
  {
    "Code":"CRIP L HND",
    "Description":"Crippled hand, left"
  },
  {
    "Code":"CRIP L LEG",
    "Description":"Crippled leg, left"
  },
  {
    "Code":"CRIP L TOE",
    "Description":"Crippled toe(s), left (4)"
  },
  {
    "Code":"CRIP R ARM",
    "Description":"Crippled arm, right"
  },
  {
    "Code":"CRIP R FGR",
    "Description":"Crippled finger(s), right hand (2)"
  },
  {
    "Code":"CRIP R FT",
    "Description":"Crippled foot, right (3)"
  },
  {
    "Code":"CRIP R HND",
    "Description":"Crippled hand, right"
  },
  {
    "Code":"CRIP R LEG",
    "Description":"Crippled leg, right"
  },
  {
    "Code":"CRIP R TOE",
    "Description":"Crippled toe(s), right (4)"
  },
  {
    "Code":"CROSSEYED",
    "Description":"Cross-eyed"
  },
  {
    "Code":"CRUTCHES",
    "Description":"Crutches"
  },
  {
    "Code":"DA ALCOHOL",
    "Description":"Alcohol"
  },
  {
    "Code":"DA AMPHETA",
    "Description":"Amphetamines (includes stimulants, speed, etc.)"
  },
  {
    "Code":"DA BARBITU",
    "Description":"Barbiturates"
  },
  {
    "Code":"DA COCAINE",
    "Description":"Cocaine (includes crack)"
  },
  {
    "Code":"DA GLUE",
    "Description":"Glue"
  },
  {
    "Code":"DA HALLUCI",
    "Description":"Hallucinogens"
  },
  {
    "Code":"DA MARIJUA",
    "Description":"Marijuana"
  },
  {
    "Code":"DA NARCOTI",
    "Description":"Narcotics (includes heroin, morphine, Dilaudid, methadone, etc.)"
  },
  {
    "Code":"DA OTHER",
    "Description":"Other drugs of abuse not listed, identify in the MIS Field"
  },
  {
    "Code":"DA PAINT",
    "Description":"Paint (includes thinner)"
  },
  {
    "Code":"DA RITALIN",
    "Description":"Ritalin"
  },
  {
    "Code":"DA ROHYPNL",
    "Description":"Rohypnol (brand name for Flunitrazepam.  Also referred to as rophies, roofies, ruffies, and roche.)"
  },
  {
    "Code":"DEAF",
    "Description":"Deaf, left and right ears"
  },
  {
    "Code":"DEAF EAR",
    "Description":"Deaf, one ear, nonspecific"
  },
  {
    "Code":"DEAF L EAR",
    "Description":"Deaf, left ear"
  },
  {
    "Code":"DEAF MUTE",
    "Description":"Deaf-mute"
  },
  {
    "Code":"DEAF R EAR",
    "Description":"Deaf, right ear"
  },
  {
    "Code":"DENT LOW",
    "Description":"Denture, lower only"
  },
  {
    "Code":"DENT UP",
    "Description":"Denture, upper only"
  },
  {
    "Code":"DENT UP LO",
    "Description":"Denture, upper and lower"
  },
  {
    "Code":"DEV SEPTUM",
    "Description":"Deviated septum"
  },
  {
    "Code":"DIMP CHIN",
    "Description":"Dimple, chin"
  },
  {
    "Code":"DIMP L CHK",
    "Description":"Dimples, left cheek (face)"
  },
  {
    "Code":"DIMP R CHK",
    "Description":"Dimples, right cheek (face)"
  },
  {
    "Code":"DISC ABDOM",
    "Description":"Abdomen"
  },
  {
    "Code":"DISC ANKL",
    "Description":"Ankle, nonspecific"
  },
  {
    "Code":"DISC ARM",
    "Description":"Arm, nonspecific"
  },
  {
    "Code":"DISC BACK",
    "Description":"Back"
  },
  {
    "Code":"DISC BRST",
    "Description":"Breast, nonspecific"
  },
  {
    "Code":"DISC BUTTK",
    "Description":"Buttock, nonspecific"
  },
  {
    "Code":"DISC CHEEK",
    "Description":"Cheek (face), nonspecific"
  },
  {
    "Code":"DISC CHEST",
    "Description":"Chest"
  },
  {
    "Code":"DISC CHIN",
    "Description":"Chin"
  },
  {
    "Code":"DISC EAR",
    "Description":"Ear, nonspecific"
  },
  {
    "Code":"DISC EYE",
    "Description":"Eyebrow, nonspecific"
  },
  {
    "Code":"DISC FACE",
    "Description":"Face, nonspecific"
  },
  {
    "Code":"DISC FGR",
    "Description":"Finger, nonspecific"
  },
  {
    "Code":"DISC FHD",
    "Description":"Forehead"
  },
  {
    "Code":"DISC FOOT",
    "Description":"Foot, nonspecific"
  },
  {
    "Code":"DISC HEAD",
    "Description":"Head"
  },
  {
    "Code":"DISC HIP",
    "Description":"Hip, nonspecific"
  },
  {
    "Code":"DISC KNEE",
    "Description":"Knee, nonspecific"
  },
  {
    "Code":"DISC L ANK",
    "Description":"Ankle, left"
  },
  {
    "Code":"DISC L ARM",
    "Description":"Arm, left"
  },
  {
    "Code":"DISC L BRS",
    "Description":"Breast, left"
  },
  {
    "Code":"DISC L BUT",
    "Description":"Buttock, left"
  },
  {
    "Code":"DISC L CHK",
    "Description":"Cheek (face), left"
  },
  {
    "Code":"DISC L EAR",
    "Description":"Ear, left"
  },
  {
    "Code":"DISC LEG",
    "Description":"Leg, nonspecific"
  },
  {
    "Code":"DISC L EYE",
    "Description":"Eyebrow, left left eye area"
  },
  {
    "Code":"DISC L FGR",
    "Description":"Finger(s), left hand"
  },
  {
    "Code":"DISC L FT",
    "Description":"Foot, left"
  },
  {
    "Code":"DISC L HIP",
    "Description":"Hip, left"
  },
  {
    "Code":"DISC L HND",
    "Description":"Hand, left"
  },
  {
    "Code":"DISC LIP",
    "Description":"Lip, nonspecific"
  },
  {
    "Code":"DISC LKNEE",
    "Description":"Knee, left"
  },
  {
    "Code":"DISC L LEG",
    "Description":"Leg, left"
  },
  {
    "Code":"DISC L LIP",
    "Description":"Lip, lower"
  },
  {
    "Code":"DISC LSHLD",
    "Description":"Shoulder, left"
  },
  {
    "Code":"DISC LTHGH",
    "Description":"Thigh, left"
  },
  {
    "Code":"DISC L WRS",
    "Description":"Wrist, left"
  },
  {
    "Code":"DISC NECK",
    "Description":"Neck"
  },
  {
    "Code":"DISC NOSE",
    "Description":"Nose"
  },
  {
    "Code":"DISC PENIS",
    "Description":"Penis"
  },
  {
    "Code":"DISC R ANK",
    "Description":"Ankle, right"
  },
  {
    "Code":"DISC R ARM",
    "Description":"Arm, right"
  },
  {
    "Code":"DISC R BRS",
    "Description":"Breast, right"
  },
  {
    "Code":"DISC R BUT",
    "Description":"Buttock, right"
  },
  {
    "Code":"DISC R CHK",
    "Description":"Cheek (face), right"
  },
  {
    "Code":"DISC R EAR",
    "Description":"Ear, right"
  },
  {
    "Code":"DISC R EYE",
    "Description":"Eyebrow, right right eye area"
  },
  {
    "Code":"DISC R FGR",
    "Description":"Finger(s), right hand"
  },
  {
    "Code":"DISC R FT",
    "Description":"Foot, right"
  },
  {
    "Code":"DISC R HIP",
    "Description":"Hip, right"
  },
  {
    "Code":"DISC R HND",
    "Description":"Hand, right"
  },
  {
    "Code":"DISC RKNEE",
    "Description":"Knee, right"
  },
  {
    "Code":"DISC R LEG",
    "Description":"Leg, right"
  },
  {
    "Code":"DISC RSHLD",
    "Description":"Shoulder, right"
  },
  {
    "Code":"DISC RTHGH",
    "Description":"Thigh, right"
  },
  {
    "Code":"DISC R WRS",
    "Description":"Wrist, right"
  },
  {
    "Code":"DISC SHLD",
    "Description":"Shoulder, nonspecific"
  },
  {
    "Code":"DISC THGH",
    "Description":"Thigh, nonspecific"
  },
  {
    "Code":"DISC U LIP",
    "Description":"Lip, upper"
  },
  {
    "Code":"DISC WRIST",
    "Description":"Wrist, nonspecific"
  },
  {
    "Code":"EAR TUBES",
    "Description":"Tubes in ears, left and right"
  },
  {
    "Code":"EXTR BRST",
    "Description":"Extra breast, nonspecific"
  },
  {
    "Code":"EXTR CBRST",
    "Description":"Extra breast, center"
  },
  {
    "Code":"EXTR C NIP",
    "Description":"Extra nipple, center"
  },
  {
    "Code":"EXTR C VRT",
    "Description":"Extra cervical vertebra(e)"
  },
  {
    "Code":"EXTR LBRST",
    "Description":"Extra breast, left"
  },
  {
    "Code":"EXTR L FGR",
    "Description":"Extra finger(s), left hand"
  },
  {
    "Code":"EXTR L NIP",
    "Description":"Extra nipple, left"
  },
  {
    "Code":"EXTR L TOE",
    "Description":"Extra toe(s), left"
  },
  {
    "Code":"EXTR L TTH",
    "Description":"Extra tooth teeth (lower jaw)"
  },
  {
    "Code":"EXTR L VRT",
    "Description":"Extra lumbar vertebra(e)"
  },
  {
    "Code":"EXTR NIP",
    "Description":"Extra nipple, nonspecific"
  },
  {
    "Code":"EXTR RBRST",
    "Description":"Extra breast, right"
  },
  {
    "Code":"EXTR R FGR",
    "Description":"Extra finger(s), right hand"
  },
  {
    "Code":"EXTR R NIP",
    "Description":"Extra nipple, right"
  },
  {
    "Code":"EXTR R TOE",
    "Description":"Extra toe(s), right"
  },
  {
    "Code":"EXTR U TTH",
    "Description":"Extra tooth teeth (upper jaw)"
  },
  {
    "Code":"EXTR VRT",
    "Description":"Extra vertebra(e), nonspecific"
  },
  {
    "Code":"FRC ANKL",
    "Description":"Ankle, nonspecific"
  },
  {
    "Code":"FRC ARM",
    "Description":"Arm, nonspecific"
  },
  {
    "Code":"FRC BACK",
    "Description":"Back"
  },
  {
    "Code":"FRC CLAVIC",
    "Description":"Clavicle, nonspecific"
  },
  {
    "Code":"FRC FGR",
    "Description":"Finger(s), nonspecific"
  },
  {
    "Code":"FRC FOOT",
    "Description":"Foot, nonspecific"
  },
  {
    "Code":"FRC HAND",
    "Description":"Hand, nonspecific"
  },
  {
    "Code":"FRC JAW",
    "Description":"Jaw, nonspecific"
  },
  {
    "Code":"FRC KNEE",
    "Description":"Knee, nonspecific"
  },
  {
    "Code":"FRC L ANKL",
    "Description":"Ankle, left"
  },
  {
    "Code":"FRC LCLAVI",
    "Description":"Clavicle, left"
  },
  {
    "Code":"FRC LEG",
    "Description":"Leg, nonspecific"
  },
  {
    "Code":"FRC L FGR",
    "Description":"Finger(s), left hand"
  },
  {
    "Code":"FRC L FOOT",
    "Description":"Foot, left"
  },
  {
    "Code":"FRC L HAND",
    "Description":"Hand, left"
  },
  {
    "Code":"FRC L KNEE",
    "Description":"Knee, left"
  },
  {
    "Code":"FRC LL ARM",
    "Description":"Arm, lower left"
  },
  {
    "Code":"FRC LL JAW",
    "Description":"Jaw, lower left"
  },
  {
    "Code":"FRC LL LEG",
    "Description":"Leg, lower left"
  },
  {
    "Code":"FRC LPELVI",
    "Description":"Pelvic bone, left"
  },
  {
    "Code":"FRC LR ARM",
    "Description":"Arm, lower right"
  },
  {
    "Code":"FRC L RIB",
    "Description":"Rib(s), left"
  },
  {
    "Code":"FRC LR JAW",
    "Description":"Jaw, lower right"
  },
  {
    "Code":"FRC LR LEG",
    "Description":"Leg, lower right"
  },
  {
    "Code":"FRC L SHLD",
    "Description":"Shoulder, left"
  },
  {
    "Code":"FRC L TOE",
    "Description":"Toe(s), left foot"
  },
  {
    "Code":"FRC L WRST",
    "Description":"Wrist, left"
  },
  {
    "Code":"FRC NECK",
    "Description":"Neck"
  },
  {
    "Code":"FRC NOSE",
    "Description":"Nose"
  },
  {
    "Code":"FRC PELVIS",
    "Description":"Pelvis, nonspecific"
  },
  {
    "Code":"FRC R ANKL",
    "Description":"Ankle, right"
  },
  {
    "Code":"FRC RCLAVI",
    "Description":"Clavicle, right"
  },
  {
    "Code":"FRC R FGR",
    "Description":"FInger(s), right hand"
  },
  {
    "Code":"FRC R FOOT",
    "Description":"Foot, right"
  },
  {
    "Code":"FRC R HAND",
    "Description":"Hand, right"
  },
  {
    "Code":"FRC RIBS",
    "Description":"Rib(s), nonspecific"
  },
  {
    "Code":"FRC R KNEE",
    "Description":"Knee, right"
  },
  {
    "Code":"FRC RPELVI",
    "Description":"Pelvic bone, right"
  },
  {
    "Code":"FRC R RIB",
    "Description":"Rib(s), right"
  },
  {
    "Code":"FRC R SHLD",
    "Description":"Shoulder, right"
  },
  {
    "Code":"FRC R TOE",
    "Description":"Toe(s), right foot"
  },
  {
    "Code":"FRC R WRST",
    "Description":"Wrist, right"
  },
  {
    "Code":"FRC SHLD",
    "Description":"Shoulder, nonspecific"
  },
  {
    "Code":"FRC SKULL",
    "Description":"Skull"
  },
  {
    "Code":"FRC SPINE",
    "Description":"Spine"
  },
  {
    "Code":"FRC STERN",
    "Description":"Sternum"
  },
  {
    "Code":"FRC TOE",
    "Description":"Toe(s), nonspecific"
  },
  {
    "Code":"FRC UL ARM",
    "Description":"Arm, upper left"
  },
  {
    "Code":"FRC UL JAW",
    "Description":"Jaw, upper left"
  },
  {
    "Code":"FRC UL LEG",
    "Description":"Leg, upper left"
  },
  {
    "Code":"FRC UR ARM",
    "Description":"Arm, upper right"
  },
  {
    "Code":"FRC UR JAW",
    "Description":"Jaw, upper right"
  },
  {
    "Code":"FRC UR LEG",
    "Description":"Leg, upper right"
  },
  {
    "Code":"FRC WRIST",
    "Description":"Wrist, nonspecific"
  },
  {
    "Code":"FRECKLES",
    "Description":"Freckles"
  },
  {
    "Code":"GLASSES",
    "Description":"Glasses (prescription)"
  },
  {
    "Code":"GLAUCOMA",
    "Description":"Glaucoma"
  },
  {
    "Code":"GOLD TOOTH",
    "Description":"Gold tooth"
  },
  {
    "Code":"HAIR IMPL",
    "Description":"Hair implants"
  },
  {
    "Code":"HEAR AID",
    "Description":"Hearing aid"
  },
  {
    "Code":"HERMAPHR",
    "Description":"Hermaphrodite"
  },
  {
    "Code":"HFR ANKL",
    "Description":"Ankle, nonspecific"
  },
  {
    "Code":"HFR ARM",
    "Description":"Arm, nonspecific"
  },
  {
    "Code":"HFR BACK",
    "Description":"Back"
  },
  {
    "Code":"HFR CLAVIC",
    "Description":"Clavicle, nonspecific"
  },
  {
    "Code":"HFR FGR",
    "Description":"Finger(s), nonspecific"
  },
  {
    "Code":"HFR FOOT",
    "Description":"Foot, nonspecific"
  },
  {
    "Code":"HFR HAND",
    "Description":"Hand, nonspecific"
  },
  {
    "Code":"HFR JAW",
    "Description":"Jaw, nonspecific"
  },
  {
    "Code":"HFR KNEE",
    "Description":"Knee, nonspecific"
  },
  {
    "Code":"HFR L ANKL",
    "Description":"Ankle, left"
  },
  {
    "Code":"HFR LCLAVI",
    "Description":"Clavicle, left"
  },
  {
    "Code":"HFR LEG",
    "Description":"Leg, nonspecific"
  },
  {
    "Code":"HFR L FGR",
    "Description":"Finger(s), left hand"
  },
  {
    "Code":"HFR L FOOT",
    "Description":"Foot, left"
  },
  {
    "Code":"HFR L HAND",
    "Description":"Hand, left"
  },
  {
    "Code":"HFR L KNEE",
    "Description":"Knee, left"
  },
  {
    "Code":"HFR LL ARM",
    "Description":"Arm, lower left"
  },
  {
    "Code":"HFR LL JAW",
    "Description":"Jaw, lower left"
  },
  {
    "Code":"HFR LL LEG",
    "Description":"Leg, lower left"
  },
  {
    "Code":"HFR LPELVI",
    "Description":"Pelvic bone, left"
  },
  {
    "Code":"HFR LR ARM",
    "Description":"Arm, lower right"
  },
  {
    "Code":"HFR L RIB",
    "Description":"Rib(s), left"
  },
  {
    "Code":"HFR LR JAW",
    "Description":"Jaw, lower right"
  },
  {
    "Code":"HFR LR LEG",
    "Description":"Leg, lower right"
  },
  {
    "Code":"HFR L SHLD",
    "Description":"Shoulder, left"
  },
  {
    "Code":"HFR L TOE",
    "Description":"Toe(s), left foot"
  },
  {
    "Code":"HFR L WRST",
    "Description":"Wrist, left"
  },
  {
    "Code":"HFR NECK",
    "Description":"Neck"
  },
  {
    "Code":"HFR NOSE",
    "Description":"Nose"
  },
  {
    "Code":"HFR PELVIS",
    "Description":"Pelvis, nonspecific"
  },
  {
    "Code":"HFR R ANKL",
    "Description":"Ankle, right"
  },
  {
    "Code":"HFR RCLAVI",
    "Description":"Clavicle, right"
  },
  {
    "Code":"HFR R FGR",
    "Description":"Finger(s), right hand"
  },
  {
    "Code":"HFR R FOOT",
    "Description":"Foot, right"
  },
  {
    "Code":"HFR R HAND",
    "Description":"Hand, right"
  },
  {
    "Code":"HFR RIBS",
    "Description":"Rib(s), nonspecific"
  },
  {
    "Code":"HFR R KNEE",
    "Description":"Knee, right"
  },
  {
    "Code":"HFR RPELVI",
    "Description":"Pelvic bone, right"
  },
  {
    "Code":"HFR R RIB",
    "Description":"Rib(s), right"
  },
  {
    "Code":"HFR R SHLD",
    "Description":"Shoulder, right"
  },
  {
    "Code":"HFR R TOE",
    "Description":"Toe(s), right foot"
  },
  {
    "Code":"HFR R WRST",
    "Description":"Wrist, right"
  },
  {
    "Code":"HFR SHLD",
    "Description":"Shoulder, nonspecific"
  },
  {
    "Code":"HFR SKULL",
    "Description":"Skull"
  },
  {
    "Code":"HFR SPINE",
    "Description":"Spine"
  },
  {
    "Code":"HFR STERN",
    "Description":"Sternum"
  },
  {
    "Code":"HFR TOE",
    "Description":"Toe(s), nonspecific"
  },
  {
    "Code":"HFR UL ARM",
    "Description":"Arm, upper left"
  },
  {
    "Code":"HFR UL JAW",
    "Description":"Jaw, upper left"
  },
  {
    "Code":"HFR UL LEG",
    "Description":"Leg, upper left"
  },
  {
    "Code":"HFR UR ARM",
    "Description":"Arm, upper right"
  },
  {
    "Code":"HFR UR JAW",
    "Description":"Jaw, upper right"
  },
  {
    "Code":"HFR UR LEG",
    "Description":"Leg, upper right"
  },
  {
    "Code":"HFR WRIST",
    "Description":"Wrist, nonspecific"
  },
  {
    "Code":"HUMPBACKED",
    "Description":"Humpbacked"
  },
  {
    "Code":"IMPL PENIS",
    "Description":"Penile implant"
  },
  {
    "Code":"INTRA ROD",
    "Description":"Intramedullary rod"
  },
  {
    "Code":"IUD",
    "Description":"Intrauterine device"
  },
  {
    "Code":"MC ACNE",
    "Description":"Acne"
  },
  {
    "Code":"MC ADD",
    "Description":"Attention Deficit Disorder"
  },
  {
    "Code":"MC ALCOHOL",
    "Description":"Alcoholism"
  },
  {
    "Code":"MC ALLERGY",
    "Description":"Allergies (including asthma)"
  },
  {
    "Code":"MC ALZHMRS",
    "Description":"Alzheimers disease"
  },
  {
    "Code":"MC ARTHRTS",
    "Description":"Arthritis"
  },
  {
    "Code":"MC BEHAVIO",
    "Description":"Behavior disorder (including autism, depression, schizophrenia, and suicidal tendencies [past and present])"
  },
  {
    "Code":"MC BLOOD",
    "Description":"Hematological diseases (diseases of the blood - including anemia, hemophilia, leukemia, and sickle-cell anemia)"
  },
  {
    "Code":"MC CANCER",
    "Description":"Cancer"
  },
  {
    "Code":"MC DIABTIC",
    "Description":"Diabetic"
  },
  {
    "Code":"MC DOWNSYN",
    "Description":"Down Syndrome"
  },
  {
    "Code":"MC DRUGAB",
    "Description":"Drug abuse"
  },
  {
    "Code":"MC EATDIS",
    "Description":"Eating disorders"
  },
  {
    "Code":"MC HEART",
    "Description":"Heart or circulatory diseases (including circulation problems, hardening of the arteries, heart attack, heart failure, and high blood pressure)"
  },
  {
    "Code":"MC KIDNEY",
    "Description":"Kidney conditions or diseases"
  },
  {
    "Code":"MC LIVER",
    "Description":"Liver disease (including cirrhosis and hepatitis)"
  },
  {
    "Code":"MC NERVOUS",
    "Description":"Nervous conditions (including mental retardation, seizures, senility, and stroke)"
  },
  {
    "Code":"MC NRLGCAL",
    "Description":"Neurological conditions or diseases (including cerebral palsy, epilepsy, multiple sclerosis, Parkinsons disease)"
  },
  {
    "Code":"MC OTHER",
    "Description":"Other medical disorders, conditions not listed, identify in the MIS Field"
  },
  {
    "Code":"MC PARPLGC",
    "Description":"Paraplegic"
  },
  {
    "Code":"MC PASTPRE",
    "Description":"Pregnancy - past (used when the individual has had past pregnancies but is not pregnant at the time the report is written)"
  },
  {
    "Code":"MC PLMNARY",
    "Description":"Pulmonary (lung) diseases (including cystic fibrosis and emphysema)"
  },
  {
    "Code":"MC PREGNAN",
    "Description":"Pregnancy - present (used when the individual is pregnant at the time the record is entered into NCIC)"
  },
  {
    "Code":"MC QUADPLG",
    "Description":"Quadriplegic"
  },
  {
    "Code":"MC SKIN",
    "Description":"Skin disorders (including psoriasis and eczema)"
  },
  {
    "Code":"MC TB",
    "Description":"Tuberculosis"
  },
  {
    "Code":"MC THYROID",
    "Description":"Thyroid conditions or diseases"
  },
  {
    "Code":"MC TOURETE",
    "Description":"Tourettes syndrome"
  },
  {
    "Code":"MISS ADND",
    "Description":"Adenoids"
  },
  {
    "Code":"MISS APPNX",
    "Description":"Appendix"
  },
  {
    "Code":"MISS BRSTS",
    "Description":"Breasts"
  },
  {
    "Code":"MISS C VRT",
    "Description":"Cervical vertebra(e)"
  },
  {
    "Code":"MISS GALL",
    "Description":"Gallbladder"
  },
  {
    "Code":"MISS INTES",
    "Description":"Intestines"
  },
  {
    "Code":"MISS L ARM",
    "Description":"Arm, left"
  },
  {
    "Code":"MISS LBRST",
    "Description":"Breast, left"
  },
  {
    "Code":"MISS L EAR",
    "Description":"Ear, left"
  },
  {
    "Code":"MISS L EYE",
    "Description":"Eye, left"
  },
  {
    "Code":"MISS L FGR",
    "Description":"Finger(s), left hand"
  },
  {
    "Code":"MISS L FJT",
    "Description":"Finger joint(s), left hand"
  },
  {
    "Code":"MISS L FT",
    "Description":"Foot, left"
  },
  {
    "Code":"MISS L HND",
    "Description":"Hand, left"
  },
  {
    "Code":"MISS L KID",
    "Description":"Kidney, left"
  },
  {
    "Code":"MISS LLARM",
    "Description":"Arm, lower left"
  },
  {
    "Code":"MISS L LEG",
    "Description":"Leg, left"
  },
  {
    "Code":"MISS LLLEG",
    "Description":"Leg, lower left"
  },
  {
    "Code":"MISS LLUNG",
    "Description":"Lung, left"
  },
  {
    "Code":"MISS LOVAR",
    "Description":"Ovary, left"
  },
  {
    "Code":"MISS LRARM",
    "Description":"Arm, lower right"
  },
  {
    "Code":"MISS LRLEG",
    "Description":"Leg, lower right"
  },
  {
    "Code":"MISS LRYNX",
    "Description":"Larynx"
  },
  {
    "Code":"MISS L TES",
    "Description":"Testis, left"
  },
  {
    "Code":"MISS L TOE",
    "Description":"Toe(s), left foot"
  },
  {
    "Code":"MISS L VRT",
    "Description":"Lumbar vertebra(e)"
  },
  {
    "Code":"MISS NOSE",
    "Description":"Nose"
  },
  {
    "Code":"MISS OVARS",
    "Description":"Ovaries"
  },
  {
    "Code":"MISS PANCR",
    "Description":"Pancreas"
  },
  {
    "Code":"MISS PENIS",
    "Description":"Penis"
  },
  {
    "Code":"MISS PROST",
    "Description":"Prostate gland"
  },
  {
    "Code":"MISS R ARM",
    "Description":"Arm, right"
  },
  {
    "Code":"MISS RBRST",
    "Description":"Breast, right"
  },
  {
    "Code":"MISS R EAR",
    "Description":"Ear, right"
  },
  {
    "Code":"MISS R EYE",
    "Description":"Eye, right"
  },
  {
    "Code":"MISS R FGR",
    "Description":"Finger(s), right hand"
  },
  {
    "Code":"MISS R FJT",
    "Description":"Finger joint(s), right hand"
  },
  {
    "Code":"MISS R FT",
    "Description":"Foot, right"
  },
  {
    "Code":"MISS R HND",
    "Description":"Hand, right"
  },
  {
    "Code":"MISS R KID",
    "Description":"Kidney, right"
  },
  {
    "Code":"MISS R LEG",
    "Description":"Leg, right"
  },
  {
    "Code":"MISS RLUNG",
    "Description":"Lung, right"
  },
  {
    "Code":"MISS ROVAR",
    "Description":"Ovary, right"
  },
  {
    "Code":"MISS R TES",
    "Description":"Testis, right"
  },
  {
    "Code":"MISS R TOE",
    "Description":"Toe(s), right foot"
  },
  {
    "Code":"MISS SPLEN",
    "Description":"Spleen"
  },
  {
    "Code":"MISS STOMA",
    "Description":"Stomach"
  },
  {
    "Code":"MISS THYRD",
    "Description":"Thyroid"
  },
  {
    "Code":"MISS TONG",
    "Description":"Tongue"
  },
  {
    "Code":"MISS TONSL",
    "Description":"Tonsils"
  },
  {
    "Code":"MISS UTRUS",
    "Description":"Uterus"
  },
  {
    "Code":"MISS VRT",
    "Description":"Vertebra(e), nonspecific"
  },
  {
    "Code":"MOLE ABDOM",
    "Description":"Abdomen"
  },
  {
    "Code":"MOLE ANKL",
    "Description":"Ankle, nonspecific"
  },
  {
    "Code":"MOLE BACK",
    "Description":"Back"
  },
  {
    "Code":"MOLE BRST",
    "Description":"Breast, nonspecific"
  },
  {
    "Code":"MOLE BUTTK",
    "Description":"Buttocks, nonspecific"
  },
  {
    "Code":"MOLE CHEST",
    "Description":"Chest"
  },
  {
    "Code":"MOLE CHIN",
    "Description":"Chin"
  },
  {
    "Code":"MOLE CHK",
    "Description":"Cheek (face), nonspecific"
  },
  {
    "Code":"MOLE EAR",
    "Description":"Ear, nonspecific"
  },
  {
    "Code":"MOLE FGR",
    "Description":"Finger(s), nonspecific"
  },
  {
    "Code":"MOLE FHD",
    "Description":"Forehead"
  },
  {
    "Code":"MOLE FOOT",
    "Description":"Foot, nonspecific"
  },
  {
    "Code":"MOLE GROIN",
    "Description":"Groin area"
  },
  {
    "Code":"MOLE HAND",
    "Description":"Hand, nonspecific"
  },
  {
    "Code":"MOLE HEAD",
    "Description":"Head, nonspecific "
  },
  {
    "Code":"MOLE HIP",
    "Description":"Hip, nonspecific"
  },
  {
    "Code":"MOLE KNEE",
    "Description":"Knee, nonspecific"
  },
  {
    "Code":"MOLE L ANK",
    "Description":"Ankle, left"
  },
  {
    "Code":"MOLE L ARM",
    "Description":"Arm, left"
  },
  {
    "Code":"MOLE LBRST",
    "Description":"Breast, left"
  },
  {
    "Code":"MOLE L BUT",
    "Description":"Buttock, left"
  },
  {
    "Code":"MOLE L CHK",
    "Description":"Cheek (face), left"
  },
  {
    "Code":"MOLE L EAR",
    "Description":"Ear, left"
  },
  {
    "Code":"MOLE LEG",
    "Description":"Leg, nonspecific"
  },
  {
    "Code":"MOLE L EYE",
    "Description":"Eyebrow, left, left eye area"
  },
  {
    "Code":"MOLE L FGR",
    "Description":"Finger(s), left hand"
  },
  {
    "Code":"MOLE L FT",
    "Description":"Foot, left"
  },
  {
    "Code":"MOLE L HIP",
    "Description":"Hip, left"
  },
  {
    "Code":"MOLE L HND",
    "Description":"Hand, left"
  },
  {
    "Code":"MOLE LIP",
    "Description":"Lip, nonspecific"
  },
  {
    "Code":"MOLE L KNE",
    "Description":"Knee, left"
  },
  {
    "Code":"MOLE L LEG",
    "Description":"Leg, left"
  },
  {
    "Code":"MOLE L LIP",
    "Description":"Lip, lower"
  },
  {
    "Code":"MOLE L SHD",
    "Description":"Shoulder, left"
  },
  {
    "Code":"MOLE L THG",
    "Description":"Thigh, left"
  },
  {
    "Code":"MOLE L WRS",
    "Description":"Wrist, left"
  },
  {
    "Code":"MOLE NECK",
    "Description":"Neck"
  },
  {
    "Code":"MOLE NOSE",
    "Description":"Nose"
  },
  {
    "Code":"MOLE PENIS",
    "Description":"Penis"
  },
  {
    "Code":"MOLE R ANK",
    "Description":"Ankle, right"
  },
  {
    "Code":"MOLE R ARM",
    "Description":"Arm, right"
  },
  {
    "Code":"MOLE RBRST",
    "Description":"Breast, right"
  },
  {
    "Code":"MOLE R BUT",
    "Description":"Buttock, right"
  },
  {
    "Code":"MOLE R CHK",
    "Description":"Cheek (face), right"
  },
  {
    "Code":"MOLE R EAR",
    "Description":"Ear, right"
  },
  {
    "Code":"MOLE R EYE",
    "Description":"Eyebrow, right, right eye area"
  },
  {
    "Code":"MOLE R FGR",
    "Description":"Finger(s), right hand"
  },
  {
    "Code":"MOLE R FT",
    "Description":"Foot, right"
  },
  {
    "Code":"MOLE R HIP",
    "Description":"Hip, right"
  },
  {
    "Code":"MOLE R HND",
    "Description":"Hand, right"
  },
  {
    "Code":"MOLE R KNE",
    "Description":"Knee, right"
  },
  {
    "Code":"MOLE R LEG",
    "Description":"Leg, right"
  },
  {
    "Code":"MOLE R SHD",
    "Description":"Shoulder, right"
  },
  {
    "Code":"MOLE R THG",
    "Description":"Thigh, right"
  },
  {
    "Code":"MOLE R WRS",
    "Description":"Wrist, right"
  },
  {
    "Code":"MOLE SHLD",
    "Description":"Shoulder, nonspecific"
  },
  {
    "Code":"MOLE THGH",
    "Description":"Thigh, nonspecific"
  },
  {
    "Code":"MOLE U LIP",
    "Description":"Lip, upper"
  },
  {
    "Code":"MUTE",
    "Description":"Mute (5)"
  },
  {
    "Code":"NM L ARM",
    "Description":"Arm, left"
  },
  {
    "Code":"NM L BUTTK",
    "Description":"Buttock, left"
  },
  {
    "Code":"NM L FGR",
    "Description":"Finger(s), left hand"
  },
  {
    "Code":"NM L FOOT",
    "Description":"Foot, left"
  },
  {
    "Code":"NM L HND",
    "Description":"Hand, left"
  },
  {
    "Code":"NM L LEG",
    "Description":"Leg, left"
  },
  {
    "Code":"NM L THIGH",
    "Description":"Thigh, left"
  },
  {
    "Code":"NM L WRIST",
    "Description":"Wrist, left"
  },
  {
    "Code":"NM R ARM",
    "Description":"Arm, right"
  },
  {
    "Code":"NM R BUTTK",
    "Description":"Buttock, right"
  },
  {
    "Code":"NM R FGR",
    "Description":"Finger(s), right hand"
  },
  {
    "Code":"NM R FOOT",
    "Description":"Foot, right"
  },
  {
    "Code":"NM R HND",
    "Description":"Hand, right"
  },
  {
    "Code":"NM R LEG",
    "Description":"Leg, right"
  },
  {
    "Code":"NM R THIGH",
    "Description":"Thigh, right"
  },
  {
    "Code":"NM R WRIST",
    "Description":"Wrist, right"
  },
  {
    "Code":"ORTH NAIL",
    "Description":"Orthopedic nail or pin"
  },
  {
    "Code":"ORTH PLATE",
    "Description":"Orthopedic plate"
  },
  {
    "Code":"ORTH SCREW",
    "Description":"Orthopedic screw"
  },
  {
    "Code":"POCKMARKS",
    "Description":"Pockmarks"
  },
  {
    "Code":"PRCD ABDMN",
    "Description":"Pierced abdomen"
  },
  {
    "Code":"PRCD BACK",
    "Description":"Pierced back"
  },
  {
    "Code":"PRCD CHIN",
    "Description":"Pierced chin"
  },
  {
    "Code":"PRCD EAR",
    "Description":"Pierced ear, one, nonspecific"
  },
  {
    "Code":"PRCD EARS",
    "Description":"Pierced ears"
  },
  {
    "Code":"PRCD EYE",
    "Description":"Pierced eyebrow, nonspecific"
  },
  {
    "Code":"PRCD FACE",
    "Description":"Pierced face, nonspecific"
  },
  {
    "Code":"PRCD GNTLS",
    "Description":"Pierced genitalia"
  },
  {
    "Code":"PRCD L EAR",
    "Description":"Pierced ear, left"
  },
  {
    "Code":"PRCD L EYE",
    "Description":"Pierced eyebrow, left"
  },
  {
    "Code":"PRCD LIP",
    "Description":"Pierced lip, nonspecific"
  },
  {
    "Code":"PRCD LLIP",
    "Description":"Pierced lip, lower"
  },
  {
    "Code":"PRCD L NIP",
    "Description":"Pierced nipple, left"
  },
  {
    "Code":"PRCD NIPPL",
    "Description":"Pierced nipple, nonspecific"
  },
  {
    "Code":"PRCD NOSE",
    "Description":"Pierced nose"
  },
  {
    "Code":"PRCD R EAR",
    "Description":"Pierced ear, right"
  },
  {
    "Code":"PRCD R EYE",
    "Description":"Pierced eyebrow, right"
  },
  {
    "Code":"PRCD R NIP",
    "Description":"Pierced nipple, right"
  },
  {
    "Code":"PRCD TONGU",
    "Description":"Pierced tongue"
  },
  {
    "Code":"PRCD ULIP",
    "Description":"Pierced lip, upper"
  },
  {
    "Code":"PROT L JAW",
    "Description":"Protruding lower jaw"
  },
  {
    "Code":"PROT U JAW",
    "Description":"Protruding upper jaw"
  },
  {
    "Code":"RTAT ABDM",
    "Description":"Abdomen"
  },
  {
    "Code":"RTAT ANKL",
    "Description":"Ankle, nonspecific"
  },
  {
    "Code":"RTAT ARM",
    "Description":"Arm, nonspecific"
  },
  {
    "Code":"RTAT BACK",
    "Description":"Back"
  },
  {
    "Code":"RTAT BRST",
    "Description":"Breast, nonspecific"
  },
  {
    "Code":"RTAT BUTTK",
    "Description":"Buttocks, nonspecific"
  },
  {
    "Code":"RTAT CALF",
    "Description":"Calf, nonspecific"
  },
  {
    "Code":"RTAT CHEEK",
    "Description":"Cheek (face), nonspecific"
  },
  {
    "Code":"RTAT CHEST",
    "Description":"Chest"
  },
  {
    "Code":"RTAT CHIN",
    "Description":"Chin"
  },
  {
    "Code":"RTAT EAR",
    "Description":"Ear, nonspecific"
  },
  {
    "Code":"RTAT ELBOW",
    "Description":"Elbow, nonspecific"
  },
  {
    "Code":"RTAT FACE",
    "Description":"Face, nonspecific"
  },
  {
    "Code":"RTAT FARM",
    "Description":"Forearm, nonspecific"
  },
  {
    "Code":"RTAT FHD",
    "Description":"Forehead"
  },
  {
    "Code":"RTAT FLBOD",
    "Description":"Full body"
  },
  {
    "Code":"RTAT FNGR",
    "Description":"Finger, nonspecific"
  },
  {
    "Code":"RTAT FOOT",
    "Description":"Foot, nonspecific"
  },
  {
    "Code":"RTAT GROIN",
    "Description":"Groin area"
  },
  {
    "Code":"RTAT HAND",
    "Description":"Hand, nonspecific"
  },
  {
    "Code":"RTAT HEAD",
    "Description":"Head, nonspecific "
  },
  {
    "Code":"RTAT HIP",
    "Description":"Hip, nonspecific"
  },
  {
    "Code":"RTAT KNEE",
    "Description":"Knee, nonspecific"
  },
  {
    "Code":"RTAT LANKL",
    "Description":"Ankle, left"
  },
  {
    "Code":"RTAT L ARM",
    "Description":"Arm, left"
  },
  {
    "Code":"RTAT LBRST",
    "Description":"Breast, left"
  },
  {
    "Code":"RTAT LBUTK",
    "Description":"Buttock, left"
  },
  {
    "Code":"RTAT LCALF",
    "Description":"Calf, left"
  },
  {
    "Code":"RTAT L CHK",
    "Description":"Cheek (face), left"
  },
  {
    "Code":"RTAT L EAR",
    "Description":"Ear, left"
  },
  {
    "Code":"RTAT LEG",
    "Description":"Leg, nonspecific"
  },
  {
    "Code":"RTAT L ELB",
    "Description":"Elbow, left"
  },
  {
    "Code":"RTAT LFARM",
    "Description":"Forearm, left"
  },
  {
    "Code":"RTAT L FGR",
    "Description":"Finger(s), left hand"
  },
  {
    "Code":"RTAT LFOOT",
    "Description":"Foot, left"
  },
  {
    "Code":"RTAT L HIP",
    "Description":"Hip, left"
  },
  {
    "Code":"RTAT L HND",
    "Description":"Hand, left"
  },
  {
    "Code":"RTAT LIP",
    "Description":"Lip, nonspecific"
  },
  {
    "Code":"RTAT LKNEE",
    "Description":"Knee, left"
  },
  {
    "Code":"RTAT L LEG",
    "Description":"Leg, left"
  },
  {
    "Code":"RTAT LSHLD",
    "Description":"Shoulder, left"
  },
  {
    "Code":"RTAT LTHGH",
    "Description":"Thigh, left"
  },
  {
    "Code":"RTAT LWLIP",
    "Description":"Lip, lower"
  },
  {
    "Code":"RTAT LWRS",
    "Description":"Wrist, left"
  },
  {
    "Code":"RTAT NECK",
    "Description":"Neck"
  },
  {
    "Code":"RTAT NOSE",
    "Description":"Nose"
  },
  {
    "Code":"RTAT PENIS",
    "Description":"Penis"
  },
  {
    "Code":"RTAT RANKL",
    "Description":"Ankle, right"
  },
  {
    "Code":"RTAT R ARM",
    "Description":"Arm, right"
  },
  {
    "Code":"RTAT RBRST",
    "Description":"Breast, right"
  },
  {
    "Code":"RTAT RBUTK",
    "Description":"Buttock, right"
  },
  {
    "Code":"RTAT RCALF",
    "Description":"Calf, right"
  },
  {
    "Code":"RTAT R CHK",
    "Description":"Cheek (face), right"
  },
  {
    "Code":"RTAT R EAR",
    "Description":"Ear, right"
  },
  {
    "Code":"RTAT R ELB",
    "Description":"Elbow, right"
  },
  {
    "Code":"RTAT RFARM",
    "Description":"Forearm, right"
  },
  {
    "Code":"RTAT R FGR",
    "Description":"Finger(s), right hand"
  },
  {
    "Code":"RTAT RFOOT",
    "Description":"Foot, right"
  },
  {
    "Code":"RTAT R HIP",
    "Description":"Hip, right"
  },
  {
    "Code":"RTAT R HND",
    "Description":"Hand, right"
  },
  {
    "Code":"RTAT RKNEE",
    "Description":"Knee, right"
  },
  {
    "Code":"RTAT R LEG",
    "Description":"Leg, right"
  },
  {
    "Code":"RTAT RSHLD",
    "Description":"Shoulder, right"
  },
  {
    "Code":"RTAT RTHGH",
    "Description":"Thigh, right"
  },
  {
    "Code":"RTAT RWRS",
    "Description":"Wrist, right"
  },
  {
    "Code":"RTAT SHLD",
    "Description":"Shoulder, nonspecific"
  },
  {
    "Code":"RTAT THGH",
    "Description":"Thigh, nonspecific"
  },
  {
    "Code":"RTAT ULARM",
    "Description":"Arm, left upper"
  },
  {
    "Code":"RTAT UPLIP",
    "Description":"Lip, upper"
  },
  {
    "Code":"RTAT URARM",
    "Description":"Arm, right upper"
  },
  {
    "Code":"RTAT WRS",
    "Description":"Wrist, nonspecific"
  },
  {
    "Code":"SC ABDOM",
    "Description":"Abdomen"
  },
  {
    "Code":"SC ANKL",
    "Description":"Ankle, nonspecific"
  },
  {
    "Code":"SC ARM",
    "Description":"Arm, nonspecific"
  },
  {
    "Code":"SC BACK",
    "Description":"Back"
  },
  {
    "Code":"SC BREAST",
    "Description":"Breast, nonspecific"
  },
  {
    "Code":"SC BUTTK",
    "Description":"Buttock, nonspecific"
  },
  {
    "Code":"SC CALF",
    "Description":"Calf, nonspecific"
  },
  {
    "Code":"SC CHEST",
    "Description":"Chest"
  },
  {
    "Code":"SC CHIN",
    "Description":"Chin"
  },
  {
    "Code":"SC CHK",
    "Description":"Cheek (face), nonspecific"
  },
  {
    "Code":"SC EAR",
    "Description":"Ear, nonspecific"
  },
  {
    "Code":"SC ELBOW",
    "Description":"Elbow, nonspecific"
  },
  {
    "Code":"SC EYE",
    "Description":"Eyebrow, nonspecific"
  },
  {
    "Code":"SC FACE",
    "Description":"Face, nonspecific"
  },
  {
    "Code":"SC F ARM",
    "Description":"Forearm, nonspecific"
  },
  {
    "Code":"SC FGR",
    "Description":"Finger, nonspecific"
  },
  {
    "Code":"SC FHD",
    "Description":"Forehead"
  },
  {
    "Code":"SC FOOT",
    "Description":"Foot, nonspecific"
  },
  {
    "Code":"SC GROIN",
    "Description":"Groin area"
  },
  {
    "Code":"SC HAND",
    "Description":"Hand, nonspecific"
  },
  {
    "Code":"SC HEAD",
    "Description":"Head, nonspecific"
  },
  {
    "Code":"SC HIP",
    "Description":"Hip, nonspecific"
  },
  {
    "Code":"SC KNEE",
    "Description":"Knee, nonspecific"
  },
  {
    "Code":"SC L ANKL",
    "Description":"Ankle, left"
  },
  {
    "Code":"SC L ARM",
    "Description":"Arm, left"
  },
  {
    "Code":"SC L BRST",
    "Description":"Breast, left"
  },
  {
    "Code":"SC L BUTTK",
    "Description":"Buttock, left"
  },
  {
    "Code":"SC L CALF",
    "Description":"Calf, left"
  },
  {
    "Code":"SC L CHK",
    "Description":"Cheek (face), left"
  },
  {
    "Code":"SC L EAR",
    "Description":"Ear, left"
  },
  {
    "Code":"SC LEG",
    "Description":"Leg, nonspecific"
  },
  {
    "Code":"SC L ELB",
    "Description":"Elbow, left"
  },
  {
    "Code":"SC L EYE",
    "Description":"Eyebrow, left, left eye area"
  },
  {
    "Code":"SC LF ARM",
    "Description":"Forearm, left"
  },
  {
    "Code":"SC L FGR",
    "Description":"Finger(s), left hand"
  },
  {
    "Code":"SC L FT",
    "Description":"Foot, left"
  },
  {
    "Code":"SC L HIP",
    "Description":"Hip, left"
  },
  {
    "Code":"SC L HND",
    "Description":"Hand, left"
  },
  {
    "Code":"SC LIP",
    "Description":"Lip, nonspecific"
  },
  {
    "Code":"SC L KNEE",
    "Description":"Knee, left"
  },
  {
    "Code":"SC L LEG",
    "Description":"Leg, left, nonspecific"
  },
  {
    "Code":"SC LOW LIP",
    "Description":"Lip, lower"
  },
  {
    "Code":"SC L SHLD",
    "Description":"Shoulder, left"
  },
  {
    "Code":"SC L THGH",
    "Description":"Thigh, left"
  },
  {
    "Code":"SC L WRIST",
    "Description":"Wrist, left"
  },
  {
    "Code":"SC NECK",
    "Description":"Neck"
  },
  {
    "Code":"SC NOSE",
    "Description":"Nose"
  },
  {
    "Code":"SC PENIS",
    "Description":"Penis"
  },
  {
    "Code":"SC R ANKL",
    "Description":"Ankle, right"
  },
  {
    "Code":"SC R ARM",
    "Description":"Arm, right"
  },
  {
    "Code":"SC R BRST",
    "Description":"Breast, right"
  },
  {
    "Code":"SC R BUTTK",
    "Description":"Buttock, right"
  },
  {
    "Code":"SC R CALF",
    "Description":"Calf, right"
  },
  {
    "Code":"SC R CHK",
    "Description":"Cheek (face), right"
  },
  {
    "Code":"SC R EAR",
    "Description":"Ear, right"
  },
  {
    "Code":"SC R ELB",
    "Description":"Elbow, right"
  },
  {
    "Code":"SC R EYE",
    "Description":"Eyebrow, right, right eye area"
  },
  {
    "Code":"SC RF ARM",
    "Description":"Forearm, right"
  },
  {
    "Code":"SC R FGR",
    "Description":"Finger(s), right hand"
  },
  {
    "Code":"SC R FT",
    "Description":"Foot, right"
  },
  {
    "Code":"SC R HIP",
    "Description":"Hip, right"
  },
  {
    "Code":"SC R HND",
    "Description":"Hand, right"
  },
  {
    "Code":"SC R KNEE",
    "Description":"Knee, right"
  },
  {
    "Code":"SC R LEG",
    "Description":"Leg, right, nonspecific"
  },
  {
    "Code":"SC R SHLD",
    "Description":"Shoulder, right"
  },
  {
    "Code":"SC R THGH",
    "Description":"Thigh, right"
  },
  {
    "Code":"SC R WRIST",
    "Description":"Wrist, right"
  },
  {
    "Code":"SC SHLD",
    "Description":"Shoulder, nonspecific"
  },
  {
    "Code":"SC THGH",
    "Description":"Thigh, nonspecific"
  },
  {
    "Code":"SC UL ARM",
    "Description":"Arm, left upper"
  },
  {
    "Code":"SC UP LIP",
    "Description":"Lip, upper"
  },
  {
    "Code":"SC UR ARM",
    "Description":"Arm, right upper"
  },
  {
    "Code":"SC WRIST",
    "Description":"Wrist, nonspecific"
  },
  {
    "Code":"SHRT L LEG",
    "Description":"Shorter left leg"
  },
  {
    "Code":"SHRT R LEG",
    "Description":"Shorter right leg"
  },
  {
    "Code":"SHUNT ART",
    "Description":"Shunt, arterial vascular"
  },
  {
    "Code":"SHUNT CERB",
    "Description":"Shunt, cerebral ventricle"
  },
  {
    "Code":"SKL PLATE",
    "Description":"Skull plate"
  },
  {
    "Code":"SLVR TOOTH",
    "Description":"Silver tooth"
  },
  {
    "Code":"STAPLES",
    "Description":"Staples"
  },
  {
    "Code":"STUTTERS",
    "Description":"Stutters"
  },
  {
    "Code":"TAT ABDOM",
    "Description":"Abdomen"
  },
  {
    "Code":"TAT ANKL",
    "Description":"Ankle, nonspecific"
  },
  {
    "Code":"TAT ARM",
    "Description":"Arm, nonspecific"
  },
  {
    "Code":"TAT BACK",
    "Description":"Back"
  },
  {
    "Code":"TAT BREAST",
    "Description":"Breast, nonspecific"
  },
  {
    "Code":"TAT BUTTK",
    "Description":"Buttocks, nonspecific"
  },
  {
    "Code":"TAT CALF",
    "Description":"Calf, nonspecific"
  },
  {
    "Code":"TAT CHEEK",
    "Description":"Cheek (face), nonspecific"
  },
  {
    "Code":"TAT CHEST",
    "Description":"Chest"
  },
  {
    "Code":"TAT CHIN",
    "Description":"Chin"
  },
  {
    "Code":"TAT EAR",
    "Description":"Ear, nonspecific"
  },
  {
    "Code":"TAT ELBOW",
    "Description":"Elbow, nonspecific"
  },
  {
    "Code":"TAT EYE",
    "Description":"Eye, nonspecific"
  },
  {
    "Code":"TAT FACE",
    "Description":"Face, nonspecific"
  },
  {
    "Code":"TAT FARM",
    "Description":"Forearm, nonspecific"
  },
  {
    "Code":"TAT FHD",
    "Description":"Forehead"
  },
  {
    "Code":"TAT FLBODY",
    "Description":"Full body (used when arms, legs, chest, and back are covered with tattoos)"
  },
  {
    "Code":"TAT FNGR",
    "Description":"Finger, nonspecific"
  },
  {
    "Code":"TAT FOOT",
    "Description":"Foot, nonspecific"
  },
  {
    "Code":"TAT GROIN",
    "Description":"Groin area"
  },
  {
    "Code":"TAT HAND",
    "Description":"Hand, nonspecific"
  },
  {
    "Code":"TAT HEAD",
    "Description":"Head, nonspecific "
  },
  {
    "Code":"TAT HIP",
    "Description":"Hip, nonspecific"
  },
  {
    "Code":"TAT KNEE",
    "Description":"Knee, nonspecific"
  },
  {
    "Code":"TAT L ANKL",
    "Description":"Ankle, left"
  },
  {
    "Code":"TAT L ARM",
    "Description":"Arm, left"
  },
  {
    "Code":"TAT L BRST",
    "Description":"Breast, left"
  },
  {
    "Code":"TAT L BUTK",
    "Description":"Buttock, left"
  },
  {
    "Code":"TAT L CALF",
    "Description":"Calf, left"
  },
  {
    "Code":"TAT L CHK",
    "Description":"Cheek (face), left"
  },
  {
    "Code":"TAT L EAR",
    "Description":"Ear, left"
  },
  {
    "Code":"TAT LEG",
    "Description":"Leg, nonspecific"
  },
  {
    "Code":"TAT LELBOW",
    "Description":"Elbow, left"
  },
  {
    "Code":"TAT L EYE",
    "Description":"Eye, left"
  },
  {
    "Code":"TAT LF ARM",
    "Description":"Forearm, left"
  },
  {
    "Code":"TAT L FGR",
    "Description":"Finger(s), left hand"
  },
  {
    "Code":"TAT L FOOT",
    "Description":"Foot, left"
  },
  {
    "Code":"TAT L HIP",
    "Description":"Hip, left"
  },
  {
    "Code":"TAT L HND",
    "Description":"Hand, left"
  },
  {
    "Code":"TAT LIP",
    "Description":"Lip, nonspecific"
  },
  {
    "Code":"TAT L KNEE",
    "Description":"Knee, left"
  },
  {
    "Code":"TAT L LEG",
    "Description":"Leg, left"
  },
  {
    "Code":"TAT L SHLD",
    "Description":"Shoulder, left"
  },
  {
    "Code":"TAT L THGH",
    "Description":"Thigh, left"
  },
  {
    "Code":"TAT L TOE",
    "Description":"Toes, left foot"
  },
  {
    "Code":"TAT LW LIP",
    "Description":"Lip, lower"
  },
  {
    "Code":"TAT L WRS",
    "Description":"Wrist, left"
  },
  {
    "Code":"TAT NECK",
    "Description":"Neck"
  },
  {
    "Code":"TAT NOSE",
    "Description":"Nose"
  },
  {
    "Code":"TAT PENIS",
    "Description":"Penis"
  },
  {
    "Code":"TAT R ANKL",
    "Description":"Ankle, right"
  },
  {
    "Code":"TAT R ARM",
    "Description":"Arm, right"
  },
  {
    "Code":"TAT R BRST",
    "Description":"Breast, right"
  },
  {
    "Code":"TAT R BUTK",
    "Description":"Buttock, right"
  },
  {
    "Code":"TAT R CALF",
    "Description":"Calf, right"
  },
  {
    "Code":"TAT R CHK",
    "Description":"Cheek (face), right"
  },
  {
    "Code":"TAT R EAR",
    "Description":"Ear, right"
  },
  {
    "Code":"TAT RELBOW",
    "Description":"Elbow, right"
  },
  {
    "Code":"TAT R EYE",
    "Description":"Eye, right"
  },
  {
    "Code":"TAT RF ARM",
    "Description":"Forearm, right"
  },
  {
    "Code":"TAT R FGR",
    "Description":"Finger(s), right hand"
  },
  {
    "Code":"TAT R FOOT",
    "Description":"Foot, right"
  },
  {
    "Code":"TAT R HIP",
    "Description":"Hip, right"
  },
  {
    "Code":"TAT R HND",
    "Description":"Hand, right"
  },
  {
    "Code":"TAT R KNEE",
    "Description":"Knee, right"
  },
  {
    "Code":"TAT R LEG",
    "Description":"Leg, right"
  },
  {
    "Code":"TAT R SHLD",
    "Description":"Shoulder, right"
  },
  {
    "Code":"TAT R THGH",
    "Description":"Thigh, right"
  },
  {
    "Code":"TAT R TOE",
    "Description":"Toes, right foot"
  },
  {
    "Code":"TAT R WRS",
    "Description":"Wrist, right"
  },
  {
    "Code":"TAT SHLD",
    "Description":"Shoulder, nonspecific"
  },
  {
    "Code":"TAT THGH",
    "Description":"Thigh, nonspecific"
  },
  {
    "Code":"TAT TOE",
    "Description":"Toes, nonspecific"
  },
  {
    "Code":"TAT UL ARM",
    "Description":"Arm, left upper"
  },
  {
    "Code":"TAT UP LIP",
    "Description":"Lip, upper"
  },
  {
    "Code":"TAT UR ARM",
    "Description":"Arm, right upper"
  },
  {
    "Code":"TAT WRS",
    "Description":"Wrist, nonspecific"
  },
  {
    "Code":"TD ACONVUL",
    "Description":"Anticonvulsants (seizure medicines) (includes Dilantin, Mysoline, phenobarbital, etc.)"
  },
  {
    "Code":"TD ADEPRES",
    "Description":"Antidepressants (mood-lifters) (includes amitriptylene, Elavil, Norpramine, Prozac, Triavil, Zoloft, etc.)"
  },
  {
    "Code":"TD ANALGES",
    "Description":"Analgesics (pain relievers) (includes Darvon, acetaminophen, aspirin, etc.)"
  },
  {
    "Code":"TD ANTBTCS",
    "Description":"Antibiotics"
  },
  {
    "Code":"TD ANTINFL",
    "Description":"Anti-inflammatory medication"
  },
  {
    "Code":"TD BRNCHDL",
    "Description":"Bronchial dilators (includes inhalers)"
  },
  {
    "Code":"TD CARDIAC",
    "Description":"Cardiac (heart medications) (includes digitalis, digoxin, etc.)"
  },
  {
    "Code":"TD HYPNOTI",
    "Description":"Hypnotics (sleeping aids) (includes barbiturates, chloral hydrate, glutethemide, etc.)"
  },
  {
    "Code":"TD INSULIN",
    "Description":"Insulin"
  },
  {
    "Code":"TD OTHER",
    "Description":"Other therapeutic medications not listed, identify in the MIS Field."
  },
  {
    "Code":"TD RITALIN",
    "Description":"Ritalin"
  },
  {
    "Code":"TD TRANQUI",
    "Description":"Tranquilizers (includes Valium, Thorazine, Stellazine, etc.)"
  },
  {
    "Code":"TRANSSXL",
    "Description":"Transsexual (use MIS Field to indicate what the individual was at birth and what he, she is at the time the record is entered [Example: Born male - had surgery and is now female])"
  },
  {
    "Code":"TRANSVST",
    "Description":"Transvestite"
  },
  {
    "Code":"TUBE L EAR",
    "Description":"Tube in left ear"
  },
  {
    "Code":"TUBE R EAR",
    "Description":"Tube in right ear"
  },
  {
    "Code":"VASC PROTH",
    "Description":"Vascular prosthesis"
  },
  {
    "Code":"WHEELCHAIR",
    "Description":"Wheelchair"
  },
  {
    "Code":"WIRE SUTUR",
    "Description":"Wire sutures"
  }
]